interface PlantProps {
  level: number
  unlockedItems: string[]
  compact?: boolean
}

export function Plant({ level, unlockedItems, compact = false }: PlantProps) {
  const progress = Math.min(1, level / 30)
  const scale = 0.72 + progress * 0.28
  const rewardEmoji = ['🌿', '🌼', '🦋', '🍎', '🐝', '☀️']
  const rewards = unlockedItems.map((id, index) => ({ id, label: `花园成长 ${index + 1}`, emoji: rewardEmoji[index % rewardEmoji.length] }))
  return (
    <div className={`relative flex items-end justify-center overflow-hidden rounded-[2.25rem] bg-[radial-gradient(circle_at_50%_18%,#ffffff_0,#f5f9e9_56%,#e4efd1_100%)] ${compact ? 'h-52' : 'h-72 sm:h-80'}`}>
      <div className="absolute left-6 top-6 rounded-full bg-white/75 px-3 py-1 text-sm font-extrabold text-garden-800">
        第 {level} 级
      </div>
      <div className="absolute inset-x-0 bottom-0 h-12 bg-[#d9c49d]/35" />
      <img
        src="/images/garden-plant.png"
        alt={`成长到第 ${level} 级的小植物`}
        className={`${compact ? 'h-44' : 'h-64 sm:h-72'} relative z-10 origin-bottom object-contain transition-all duration-700`}
        style={{ transform: `scale(${scale})`, filter: level === 0 ? 'saturate(.55)' : 'none' }}
      />
      <div className="absolute bottom-5 right-4 z-20 flex max-w-[42%] flex-wrap justify-end gap-1 text-2xl" aria-label="花园奖励">
        {rewards.map((reward) => <span key={reward.id} title={reward.label}>{reward.emoji}</span>)}
      </div>
    </div>
  )
}
